import { Dispatch } from "redux";
import { setWarningMessage } from "../../Redux/Slices/alert.slice";

export const validateResultData = (
  data: {
    resultType: string;
    schoolBranchId: number | null;
  },
  dispatch: Dispatch,
) => {
  const { resultType, schoolBranchId } = data;

  if (!resultType) {
    dispatch(setWarningMessage("Please enter result."));
    return false;
  }

  if (!schoolBranchId) {
    dispatch(setWarningMessage("Please select school branch."));
    return false;
  }

  return true;
};
